<ul class="ob1-item-card-list apply-one-grid apply-one-style mb-2 mt-2">
  <li>
    <div
      class="alert-container ob1-notification-message alert-info no-border"
      [attr.data-e2e]="'e2e-push-whouseit-' + push?.code"
    >
      <a
        class="ob1-item-card alert-info px-1 px-md-1 no-border"
        [attr.data-e2e]="'e2e-push-whouseit-btn-' + push?.code"
        [attr.id-ref-zone]="push?.idRefZone"
        [href]="'dashboard.bills.whoUseContract.link' | translate | link: ParamsUtils.cidMap(push.cid) | async"
        (click)="getLink(); (false)"
      >
        <span alt="" class="push-info-icon icon icon-user-unknown"></span>
        <div class="ob1-item-card-container">
          <div class="ob1-item-card-text">
            <strong>{{ push.title }}</strong>
            @if (push?.content) {
              <small class="ob1-item-card-desc push-info-desc text-mw">
                {{ push?.content }}
              </small>
            }
          </div>
        </div>
      </a>
    </div>
  </li>
</ul>
